<div class="page-container" id="{{docId}}_{{pId}}_signaturePage">




  <!-- Other actors -->
  <ng-container *ngFor="let item of getOtherActorsPlaceholders">
    <ng-container *ngIf="pId+1 === item.sigFieldPage && docId === item.documentId">
      <div class="grid grid-start" id="{{item.fieldName}}"
        [ngStyle]="{'position': 'absolute','top' : item.sigFieldY+'%', 'left': item.sigFieldX+'%'}">
        <div class="child disabled d-block">
          <div class="placeholder-field disabled" [style.width.px]="(pageWidth / 100) * item.sigFieldW"
            [style.height.px]="(pageHeight / 100) * item.sigFieldH">
            <span *ngIf="(pageWidth / 100) * item.sigFieldW < 140" class="mx-auto">{{getAcronym(item)}}</span>
            <span *ngIf="(pageWidth / 100) * item.sigFieldW >= 140" class="mx-auto">{{item.fullName}}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <!-- Current actor -->
  <ng-container *ngFor="let signatureField of signatureFields">

    <!-- Display placeholder with spinner if signature locked -->
    <div >
       <ng-container *ngIf="!signatureField.hasSigned && checkIfSignatureFieldIsInLockedDocument(signatureField)" >
        <div class="grid grid-start" [ngStyle]="{'position': 'absolute','top' : signatureField.sigFieldY+'%', 'left': signatureField.sigFieldX+'%'}">
          <div class="bg-warning position-relative overflow-hidden"
            [style.width.px]="(pageWidth / 100) * signatureField.sigFieldW"
            [style.height.px]="(pageHeight / 100) * signatureField.sigFieldH">
            <div class="position-absolute w-100 h-100 d-flex flex-column align-items-center bg-warning justify-content-center" id="signaturePlaceholder_{{signatureField.fieldName}}">
              <span class="spinner-border locked" aria-hidden="true" id="{{createSpecialFieldId(signatureField.documentId,signatureField.fieldName)}}"></span>
            </div>
          </div>
        </div>
       </ng-container>
       <!-- Display signaturefield -->
       <ng-container *ngIf="(!signatureField.hasSigned || !buttonsEnabled.value) && !checkIfSignatureFieldIsInLockedDocument(signatureField)" >
          <div class="grid grid-start" [ngStyle]="{'position': 'absolute','top' : signatureField.sigFieldY+'%', 'left': signatureField.sigFieldX+'%'}">
            <div class="child disabled d-block">
              <div class="current-placeholder-field {{ !currentActionIsThisAction(signatureField) ? 'disabled' : '' }} cursor-pointer"
                [style.width.px]="(pageWidth / 100) * signatureField.sigFieldW"
                [style.height.px]="(pageHeight / 100) * signatureField.sigFieldH" (click)="currentActionIsThisAction(signatureField) ? Sign(signatureField) : ''" id="signaturePlaceholder_{{signatureField.fieldName}}">
                <div class="mx-auto {{ currentActionIsThisAction(signatureField) ? 'active-action' : '' }} text-white" id="{{createSpecialFieldId(signatureField.documentId,signatureField.fieldName)}}">

                  <!-- Current signaturefield current actor -->
                  <ng-container *ngIf="currentActionIsThisAction(signatureField)">
                    <!-- Mobile -->
                    <div class="d-block d-md-none">
                      <span class="mx-auto" translate="Button.SignMobile"></span>
                    </div>
                    <!-- Desktop -->
                    <div class="d-none d-md-block">
                      <span class="mx-auto" translate="Button.Sign"></span>
                    </div>
                  </ng-container>

                  <!-- Next signaturefield current actor -->
                  <ng-container *ngIf="!currentActionIsThisAction(signatureField)">
                    <!-- Mobile -->
                    <div class="d-block d-md-none">
                      <span class="mx-auto">{{getAcronym(signatureField)}}</span>
                    </div>
                    <!-- Desktop -->
                    <div class="d-none d-md-block">
                      <span *ngIf="(pageWidth / 100) * signatureField.sigFieldW < 140" class="mx-auto">{{getAcronym(signatureField)}}</span>
                      <span *ngIf="(pageWidth / 100) * signatureField.sigFieldW >= 140" class="mx-auto">{{signatureField.fullName}}</span>
                    </div>
                  </ng-container>

                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <!-- Signaturefield has signed, reference -->
        <ng-container *ngIf="signatureField.hasSigned">
          <div 
            [ngStyle]="{'position': 'absolute','top' : signatureField.sigFieldY+'%', 'left': signatureField.sigFieldX+'%'}">
            <div class="placeholder-field" [style.width.px]="(pageWidth / 100) * signatureField.sigFieldW"
            [style.height.px]="((pageHeight / 100) * signatureField.sigFieldH)">
              <span id="{{signatureField.documentId + signatureField.fieldName}}">&nbsp;</span>
            </div>
          </div>
        </ng-container>
    </div>
  </ng-container>
  <img *ngIf="source !== undefined && source !== null" [src]="source" alt="Page{{pId+1}}"
    id="{{docId}}_{{pId+1}}_indicator" class="page-image-view">
  <canvas *ngIf="source === undefined || source === null" [style.width.pct]="width"
    [style.height.px]="getRightYPosition()" id="{{docId}}_{{pId+1}}_indicator"
    class="page-image-view bg-white"></canvas>
</div>